import { useState, useEffect, RefObject, SetStateAction, Dispatch } from 'react';

const useSelect = <T extends HTMLElement>(
	selectbox_ref: RefObject<T>,
	additional_func?: () => void,
): [boolean, Dispatch<SetStateAction<boolean>>] => {
	const [click_selectbox, setClickSelectbox] = useState(false);

	useEffect(() => {
		const closeSelect = (e: MouseEvent) => {
			const el = e.target;

			if (!el) return;

			if (!selectbox_ref.current?.contains(e.target as HTMLElement)) {
				setClickSelectbox(false);
				if (additional_func) {
					additional_func();
				}
			}
		};

		const keyDownEvent = (e: KeyboardEvent) => {
			const el = e.currentTarget as HTMLDivElement;
			const li_list = el.getElementsByTagName('li');
			const highest = li_list[li_list.length - 1];

			if (e.key === 'ArrowDown' && !click_selectbox) {
				setClickSelectbox(true);
			}

			if (
				e.key === 'ArrowDown' &&
				click_selectbox &&
				document.activeElement !== highest
			) {
				li_list[0].focus();
			}
		};

		selectbox_ref.current?.addEventListener('keydown', keyDownEvent);
		document.addEventListener('click', closeSelect);
		return () => {
			selectbox_ref.current?.removeEventListener('keydown', keyDownEvent);
			document.removeEventListener('click', closeSelect);
		};
	}, [selectbox_ref, click_selectbox]);

	return [click_selectbox, setClickSelectbox];
};

export default useSelect;
